import { Component, Input } from '@angular/core';

@Component({
  template: ''
})
// tslint:disable-next-line:component-class-suffix
export class SkeletonBase {
  @Input() class: string;
  @Input() style: { [klass: string]: any };
  @Input() margin: string;
  @Input() padding: string;
  @Input('primary-color') primaryColor = '#f2f2f2';
  @Input('skc-border') border = false;
  @Input('skc-border-radius') borderRadius = '7px';
  @Input('skc-animation') animation: 'line' | 'flashing' | 'ease' | 'none' = 'ease';
  @Input('disable-click') disableClick = true;
  @Input('skc-loading') loading: boolean;
}
